import $http from '../../shared/http';

export const weekdays = {
  namespaced: true,
  state: () => {
    return {
      weekdaysForSelect: null,
    };
  },
  getters: {
    getWeekdaysForSelect: (state) => (currentLanguage) => {
      const weekdays = state?.weekdaysForSelect ?? [];
      if (!currentLanguage || !weekdays.length) {
        return [];
      }

      return (
        weekdays?.map?.((weekday) => {
          return {
            value: weekday.value,
            text: weekday.weekdayLocalisations?.[currentLanguage]?.name || weekday.text,
          };
        }) ?? []
      );
    },
  },
  mutations: {
    setWeekdaysForSelect: (state, payload) => (state.weekdaysForSelect = payload),
  },
  actions: {
    async loadWeekdaysForSelect({ commit }, { usage } = {}) {
      const params = {};

      if (usage) {
        params.usage = usage;
      }

      return $http('v2')
        .get('/weekdays', { params })
        .then((response) => {
          commit('setWeekdaysForSelect', response.data.data);
          return response;
        });
    },
  },
};
